import { getNewsListApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getNewsListApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
